<template>
  <div class="page-mentor">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/company/home/${id}`"
          >企业信息</el-breadcrumb-item
        >
        <el-breadcrumb-item>企业导师</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content content">
        <column-header2 :data="metaData"></column-header2>
        <div class="column-wrap">
          <mentor-card
            v-for="item in mentorList"
            :data="item"
            :key="item.Id"
          ></mentor-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getData } from "api/app";
import SideNav from "_c/SideNav";
import ColumnHeader from "_c/ColumnHeader2";
import MemtorCard from "../components/MentorCard";

export default {
  data() {
    return {
      metaData: {
        name: "企业导师"
      },
      mentorList: [],
      id: this.$route.params.id
    };
  },
  created() {
    this.init();
  },
  components: {
    [SideNav.name]: SideNav,
    [ColumnHeader.name]: ColumnHeader,
    [MemtorCard.name]: MemtorCard
  },
  methods: {
    loadData() {
      const linkDecorator = item => {
        item.link = this.$subsitePrefix + "/company/mentor/detail/" + item.Id;
        return item;
      };
      let params = [
        {
          Key: "Enterprise",
          Value: this.$route.params.id,
          CompareType: "EqualTo"
        }
      ];
      getData({ name: "EnterpriseTutor", params: params }).then(res => {
        this.mentorList = (res || []).map(linkDecorator);
      });
    },
    init() {
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-mentor {
  background: #f6f6f9;
  padding-bottom: 40px;
  ::v-deep .comp-user {
    margin: 10px 48px 0 48px;
  }
  ::v-deep .comp-column-header {
    padding: 10px 0 20px 0;
    margin-left: 48px;
  }
}
</style>
